import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-ph-checkbox',
  templateUrl: './ph-checkbox.component.html',
  styleUrls: ['./ph-checkbox.component.scss'],
})
export class PhCheckboxComponent {
  @Input() name: string | number = Math.random();
  @Input() formEl: UntypedFormControl;
  @Input() disabled: boolean = false;
  @Input() showControl: boolean = true;

  constructor() {}
}
